import React, { useMemo, useState } from 'react';
import logo from '../../assets/images/logo.jpg';
import logoThrive from '../../assets/images/logoThrive.png';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    SidebarHeader,
    SidebarBody,
    SidebarFooter
} from './style';
import { FiX } from 'react-icons/fi';
import { FaChevronRight, FaChevronDown } from 'react-icons/fa';
import { useAuth } from '../../hooks/auth';

import RoutesList from '../../routes/routesList';

const parseUser = (user) => {
    if (user == null) return null;
    try {
        return typeof user !== 'object' ? JSON.parse(user) : user;
    } catch {
        return null;
    }
};

const parseUserRoles = (userRoles) => {
    if (userRoles == null) return [];
    try {
        return Array.isArray(userRoles) ? userRoles : JSON.parse(userRoles || '[]');
    } catch {
        return [];
    }
};

const Sidebar = ({ active, setActive, openMenu, setOpenMenu }) => {
    const navigate = useNavigate();
    const { user, userRoles } = useAuth();
    const [cultureID] = useState(localStorage.getItem('@Thrive:cultureID'));

    const userObjectAux = useMemo(() => parseUser(user), [user]);
    const userRolesParsed = useMemo(() => parseUserRoles(userRoles), [userRoles]);

    const sidebarMenuItems = useMemo(() => {
        return RoutesList.filter(item =>
            item.showInSidebar &&
            (item.allowedRoles == null || item.allowedRoles?.some(role => userRolesParsed?.includes(role))) &&
            (item.allowedCulture == null || item.allowedCulture.length === 0 || item.allowedCulture.some(culture => String(culture) === String(cultureID))) &&
            (!item?.onlyGlobal || (item?.onlyGlobal && userObjectAux?.companyID == null) || (item?.onlyBATGroup && userObjectAux?.isBATGroup))
        );
    }, [userObjectAux, userRolesParsed, cultureID]);

    return (
        <Container className={(active ? "show" : "hide")}>
            <SidebarHeader>
                <div>
                    <FiX onClick={() => { setActive(!active) }} alt="Close menu" size={20} />
                </div>
                <div>
                    <img src={logoThrive} alt="Logo Thrive Digital" width="100" height="36" />
                </div>
            </SidebarHeader>
            <SidebarBody>
                {active && <ul>
                    {sidebarMenuItems.map(item => (
                        <>
                            <li key={item.label} style={{ position: "relative", borderBottom: "1px solid #BDC7DA25" }} onClick={() => {
                                if (item.isMenu) {
                                    localStorage.setItem('@Thrive:openMenu', openMenu == item.label ? null : item.label);
                                    setOpenMenu(openMenu == item.label ? null : item.label);
                                } else {
                                    setActive(false);
                                    navigate(item.path);
                                }
                            }}>
                                {item.isMenu && (<span style={{ position: "absolute", left: 12 }}>{openMenu == item.label ? <FaChevronDown size={14} /> : <FaChevronRight size={14} />}</span>)}
                                <label>
                                    {item.label}
                                </label>
                            </li>
                            {openMenu == item.label && item.childrens && <ul>
                                {item.childrens.filter(children =>
                                    children.showInSidebar &&
                                    (children.allowedRoles == null || children.allowedRoles?.some(role => userRolesParsed?.includes(role))) &&
                                    (children.allowedCulture == null || children.allowedCulture.length === 0 || children.allowedCulture.some(culture => String(culture) === String(cultureID))) &&
                                    (!children?.onlyGlobal || (children?.onlyGlobal && userObjectAux?.companyID == null) || (children?.onlyBATGroup && userObjectAux?.isBATGroup))
                                ).map((children) => {
                                    return <li style={{ paddingLeft: 15, borderBottom: "1px solid #BDC7DA25" }} onClick={() => {
                                        setActive(false);
                                        navigate(children.path);
                                    }}>
                                        <label>{children.label}</label>
                                    </li>
                                })}
                            </ul>}
                        </>
                    ))}
                </ul>}
            </SidebarBody>
        </Container>
    );
}

export default Sidebar;
